// AuthScreen.jsx — email sign-up / login + Google sign-in. Shown when there is no session.
import React, { useState } from 'react';
import { Field, Btn, Icon, APP } from '../shared.js';
import { api } from '../lib/api.js';

function GoogleGlyph() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.02-3.7H.96v2.34A9 9 0 0 0 9 18z" />
      <path fill="#FBBC05" d="M3.98 10.72a5.4 5.4 0 0 1 0-3.44V4.94H.96a9 9 0 0 0 0 8.12l3.02-2.34z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.46 3.44 1.35l2.58-2.58C13.46.89 11.42 0 9 0A9 9 0 0 0 .96 4.94l3.02 2.34C4.68 5.16 6.66 3.58 9 3.58z" />
    </svg>
  );
}

export function AuthScreen({ onAuthed, googleEnabled, initialError }) {
  const [mode, setMode] = useState('login'); // 'login' | 'signup'
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(initialError || '');

  const isSignup = mode === 'signup';

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError('');
    setBusy(true);
    try {
      const payload = isSignup
        ? { name: name.trim(), companyName: company.trim(), email: email.trim(), password }
        : { email: email.trim(), password };
      const { user } = isSignup ? await api.signup(payload) : await api.login(payload);
      onAuthed(user);
    } catch (err) {
      setError(err.message || 'Något gick fel.');
      setBusy(false);
    }
  };

  return (
    <div className="gv-auth">
      <div className="gv-auth-brand">
        <div className="gv-auth-logo"><img src="/logotextsidan.png" alt="Giant Valley" /></div>
        <div className="gv-auth-title">Job Manager</div>
        <div className="gv-auth-sub">{APP.tagline}</div>
      </div>

      <form className="gv-auth-card" onSubmit={submit}>
        {error && <div className="gv-auth-err">{error}</div>}

        {isSignup && (
          <Field label="Ditt namn" value={name} onChange={setName} placeholder="Marcus Lindberg" />
        )}
        {isSignup && (
          <Field label="Företag (valfritt)" value={company} onChange={setCompany} placeholder="Lindberg Service & VVS" />
        )}
        <Field label="E-post" value={email} onChange={setEmail} placeholder="du@företag.se" type="email" />
        <Field label="Lösenord" value={password} onChange={setPassword} placeholder={isSignup ? 'Minst 8 tecken' : '••••••••'} type="password" />

        <Btn variant="primary" full type="submit" disabled={busy}>
          {busy ? 'Ett ögonblick…' : isSignup ? 'Skapa konto' : 'Logga in'}
        </Btn>

        {googleEnabled && (
          <>
            <div className="gv-auth-divider">eller</div>
            <button type="button" className="gv-google-btn" onClick={() => { window.location.href = api.googleLoginUrl; }}>
              <GoogleGlyph />
              Fortsätt med Google
            </button>
          </>
        )}
      </form>

      <div className="gv-auth-toggle" style={{ marginTop: 18 }}>
        {isSignup ? 'Har du redan ett konto?' : 'Inget konto än?'}{' '}
        <button type="button" onClick={() => { setError(''); setMode(isSignup ? 'login' : 'signup'); }}>
          {isSignup ? 'Logga in' : 'Skapa konto'}
        </button>
      </div>
    </div>
  );
}
